<template>
  <div class>
    <sweet-modal
      ref="modal"
      width="1000px"
      blocking
      class="publish-finish-modal"
      @close="closeAction"
    >
      <h2 class="popup-finish-title">{{ this.$t('ct-title-finish-popup') }}</h2>
      <p class="popup-finish-message">
        {{ this.$t('ct-message-finish-popup') }}
      </p>
      <label for="url">{{ $t('ct-address-url')}}</label>
      <div class="button-container">
        <div class="domain-connected">
          <p class="domain-text">{{ domain }}</p>
          <a style="wrap: no-wrapp" :href="domain" target="_blank" class="popup-save-btn-gotosite">{{ this.$t('ct-go-to-website') }}</a>
          <button @click="buyDomain()" class="popup-save-btn-buy-domain">{{ this.$t('ct-update-domain') }}</button>
        </div>
      </div>

      <builderall-social-media-share
        v-if="!isEditingLayoutItem"
        modal="false"
        :link="domain"
        :avatar="$store.state.user.gravatar"
        :shorttext="$t('ct-modal-share-shorttext', {name: title, link: domain})"
        :text="$t('ct-modal-share-text', {name: title, link: domain})"
      ></builderall-social-media-share>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
export default {
  props: ['show', 'domain', 'title'],
  name: 'ModalPublishFinishComponent',
  components: {
    SweetModal
  },
  data() {
    return {
      myInterval : '',
      timeLeft: 10,
      disabled: 1
    };
  },
  watch: {
    show: function(value) {
      if(localStorage.getItem('is_bundle') != 'exit-popup'){
        if (value){
          this.$refs.modal.open();
        } else {
          this.$refs.modal.close();
        }
      }
    }
  },
  computed: {
    isEditingLayoutItem() {
      return this.$route.name === 'editor-layout-item'
    }
  },
  methods: {
    closeAction(){
      if (!this.show) {
        return;
      }

      this.$emit('closeFinish');
    },
    buyDomain(){
      this.$emit('changeDomainAction');
    },
  }
};
</script>

<style lang="scss">
.publish-finish-modal {
  .sweet-modal {
    top: 85px;
    left: 50%;
    height: auto;
    max-height: calc(100vh - 85px);
    margin: 0;
    transform: scale(0.9) translate(calc(-50% - 32px), 0);
  }

  .sweet-modal.is-visible {
    transform: translate(-50%, 0);
  }

  .sweet-modal.bounce {
    animation-name: publish-finish-modal-bounce;
  }

  @keyframes publish-finish-modal-bounce {
    0% {
      transform: scale(1) translate(-50%, 0);
    }
    50% {
      transform: scale(1.02) translate(calc(-50% + 8px), 0);
    }
    100% {
      transform: scale(1) translate(-50%, 0);
    }
  }
  .popup-finish-title {
    color: #0072E1;
    text-align: center;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%; /* 35.2px */
  }
  .popup-finish-message {
    color: #111827;
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 700;
    line-height: 150%; /* 24px */
  }
  .popup-save-btn-buy-domain,
  .popup-save-btn-gotosite {
    cursor: pointer;
    text-transform: uppercase;
    border: none;
    border-radius: 10px;
    outline: none;
    justify-content: center;
    align-items: center;
    gap: 9.6px;
    padding: 16px 32px;
    font-size: 12px;
    font-weight: 600;
    transition: all .4s;
    display: flex;
    color: white;
  }
  .popup-save-btn-gotosite {
    background: #0072E1;
    &:hover {
      text-decoration: none;
    }
  }
  .popup-save-btn-buy-domain {
    background: #1AD9A9;
  }
}
.domain-connected{
  display: flex;
  width: 100%;
  gap: 15px;
}

.domain-text{
  border-radius: 6px;
  border: 1px solid #D5DEE9;
  background: #FAFBFC;
  display: flex;
  height: 48px;
  padding: 10px;
  align-items: center;
  align-self: stretch;
  color: #6688AE;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  flex: 1;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-close {
  background: none;
  border: none;
  outline: none;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;

  builderall-icon {
      --builderall-icon-size: 24px;
      --builderall-icon-color: #95ACCC;
  }
}

// .btn-dark{
//   background-color: #5A5959;
// }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalPublishFinish.vue